var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter, OnChanges, OnInit, SimpleChanges, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CurriculaService, CommonService, EventsService, JobOffersService, ClevertapEventsService } from '../../services';
import * as moment from 'moment';
import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { BsModalService } from 'ngx-bootstrap';
import { environment } from 'environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { ToasterService } from 'angular2-toaster';
import { LocalStorageHelpers } from 'app/helpers';
import { DigitalCareerDaysService } from 'app/services/digital-career-days.service';
import { Subject } from 'rxjs';
import { UserJobsEntityModel } from 'app/interfaces';
var CurriculumComponent = /** @class */ (function () {
    function CurriculumComponent(curriculaService, route, eventsService, commonService, modalService, jobOfferService, sanitizer, toasterService, localStorageHelper, dcds) {
        var _this = this;
        this.curriculaService = curriculaService;
        this.route = route;
        this.eventsService = eventsService;
        this.commonService = commonService;
        this.modalService = modalService;
        this.jobOfferService = jobOfferService;
        this.sanitizer = sanitizer;
        this.toasterService = toasterService;
        this.localStorageHelper = localStorageHelper;
        this.dcds = dcds;
        this.userId = null;
        this.curriculum = null;
        this.previousId = null;
        this.nextId = null;
        this.previousPage = null;
        this.nextPage = null;
        this.hideBackButton = false;
        this.careerDayId = null;
        this.careerDayExpired = false;
        this.previousClick = new EventEmitter();
        this.nextClick = new EventEmitter();
        this.previousPageClick = new EventEmitter();
        this.nextPageClick = new EventEmitter();
        this.job_id = false;
        this.applications = [];
        this.checkIns = [];
        this.statuses = {
            canSaveComment: false,
            savingComment: false,
            exportingCV: false
        };
        this.exportLabel = '';
        this.isLoading = false;
        this.interval = null;
        this.messageSent = new Subject();
        this.messageIsSent = this.messageSent.asObservable();
        var obs = this.messageIsSent.subscribe(function (isSent) {
            if (isSent && _this.interval) {
                console.log('clear interval');
                clearInterval(_this.interval);
                _this.interval = null;
            }
        });
    }
    Object.defineProperty(CurriculumComponent.prototype, "showPreviousButton", {
        // get iframeUrl(): SafeResourceUrl {
        //   return this.sanitizer.bypassSecurityTrustResourceUrl(environment.curriculumUrl);
        // }
        get: function () {
            console.log('showPreviousButton', this.previousId, this.previousPage);
            return this.previousId || this.previousPage !== null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CurriculumComponent.prototype, "showNextButton", {
        get: function () {
            console.log('showNextButton', this.nextId, this.nextPage);
            return this.nextId || this.nextPage !== null;
        },
        enumerable: true,
        configurable: true
    });
    CurriculumComponent.prototype.clickOnPrevious = function () {
        if (this.previousId) {
            this.previousClick.emit(this.previousId);
        }
        else if (this.previousPage !== null) {
            this.previousPageClick.emit(this.previousPage);
        }
    };
    CurriculumComponent.prototype.clickOnNext = function () {
        if (this.nextId) {
            this.nextClick.emit(this.nextId);
        }
        else if (this.nextPage !== null) {
            this.nextPageClick.emit(this.nextPage);
        }
    };
    CurriculumComponent.prototype.handleKeyboardEvent = function (event) {
        console.log(event);
        if (event.key === 'ArrowRight') {
            this.clickOnNext();
        }
        if (event.key === 'ArrowLeft') {
            this.clickOnPrevious();
        }
        // if (event.key === 'x') {
        //   this.changeProcessStatus(this.applications.filter(a => this.job_id === a['JobOffer']['job_id'])[0], 'rejected');
        // }
        // if (event.key === 'v') {
        //   this.changeProcessStatus(this.applications.filter(a => this.job_id === a['JobOffer']['job_id'])[0], 'compliant');
        // }
        // if (event.key === '?') {
        //   this.changeProcessStatus(this.applications.filter(a => this.job_id === a['JobOffer']['job_id'])[0], 'not_sure');
        // }
    };
    CurriculumComponent.prototype.copyToClipboard = function ($event) {
        try {
            var selBox = document.createElement('textarea');
            selBox.style.position = 'fixed';
            selBox.style.left = '0';
            selBox.style.top = '0';
            selBox.style.opacity = '0';
            // FIX-ME
            // check career day
            if (this.careerDayId !== null) {
                selBox.value = location.host + "/career_days/" + this.careerDayId + "/job-offer/" + this.jobId + "/curricula/all?cvId=" + this.userId;
            }
            else {
                selBox.value = location.host + "/recruiting/curricula/" + this.userId;
            }
            document.body.appendChild(selBox);
            selBox.focus();
            selBox.select();
            document.execCommand('copy');
            document.body.removeChild(selBox);
            this.toasterService.pop('success', 'Success', 'Candidate\'s Url copied to Clipboard!');
            // success toast
        }
        catch (e) {
            // error toast
            this.toasterService.pop('error', 'Error!', 'Please try again.');
        }
    };
    CurriculumComponent.prototype.onMessage = function (event) {
        if (event && event.data && event.data.type && event.data.type === 'message-received') {
            this.messageSent.next(true);
            console.log('message received');
        }
    };
    CurriculumComponent.prototype.ngOnChanges = function (changes) {
        this.ngOnInit();
    };
    CurriculumComponent.prototype.isImgFromFb = function (img) {
        return this.commonService.isImgFromFb(img);
    };
    CurriculumComponent.prototype.openVideo = function (video) {
        var file = video;
        window.open(file, 'targetWindow', 'toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=400, height=600, left=200, top=100');
    };
    CurriculumComponent.prototype.openConfirmModal = function (template) {
        this.template = template;
        this.includeImage = true;
        this.modalRef = this.modalService.show(template);
    };
    CurriculumComponent.prototype.downloadCv = function () {
        var iframe = document.querySelector('iframe#ionicApp');
        iframe.contentWindow.postMessage({
            parent: 'employer-app',
            token: localStorage.getItem('token') || null,
            joi: this.applier_id,
            type: 'print-curriculum-from-employer'
        }, '*');
    };
    CurriculumComponent.prototype.setViewed = function (curriculum) {
        if (curriculum && !curriculum.viewed) {
            if (curriculum.application_id) {
                this.commonService.setApplicationViewed(curriculum.application_id).subscribe();
            }
            else if (curriculum.employers_id) {
                this.commonService.setEmployersUsersViewed(curriculum.User.id).subscribe();
                ClevertapEventsService.emitEvent('openedCv', { employers_id: curriculum.employers_id });
            }
        }
    };
    CurriculumComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isLoading = true;
        this.route.params.subscribe(function (params) {
            if (!_this.userId) {
                setTimeout(function () {
                    window.scroll(0, 0);
                });
            }
            else {
                // FIX-ME focus on element
                try {
                    var elmnt = document.getElementsByTagName('app-curriculum')[0];
                    // elmnt.scrollIntoView();
                }
                catch (e) { }
            }
            var job_id = _this.jobId || _this.route.snapshot.queryParams['job_id'];
            if (job_id) {
                _this.job_id = +job_id;
            }
            if (params['applier_id'] || _this.userId) {
                _this.applier_id = _this.userId || +params['applier_id'];
                _this.curriculaService.getCurriculum(_this.applier_id, _this.job_id)
                    .subscribe(function (applier) {
                    _this.applier = __assign({}, applier, { User: {
                            img: applier.img,
                            name: applier.name,
                            surname: applier.surname,
                            status: applier.status,
                            birthdate: applier.birthdate,
                            email: applier.email,
                            contact_email: applier.contact_eamil,
                            phone: applier.phone,
                            contact_phone: applier.contact_phone,
                            contact_address: applier.contact_address
                        }, viewed: true });
                    console.log(_this.applier);
                    _this.setViewed(_this.curriculum);
                    _this.isLoading = false;
                }, function () {
                    _this.isLoading = false;
                });
                _this.refreshApplications();
                _this.curriculaService.getCheckIns(_this.applier_id)
                    .subscribe(function (checkIns) {
                    _this.checkIns = checkIns;
                    console.log('checkIns', checkIns);
                });
                // FIX-ME
                // emit event to iframe
                _this.iframeUrl = _this.sanitizer.bypassSecurityTrustResourceUrl(environment.curriculumUrl);
                if (!_this.interval) {
                    _this.interval = setInterval(function () {
                        var iframe = document.querySelector('iframe#ionicApp');
                        if (iframe) {
                            var win = void 0;
                            // some browser (don't remember which one) throw exception when you try to access
                            // contentWindow for the first time, it work when you do that second time
                            try {
                                win = iframe.contentWindow;
                            }
                            catch (e) {
                                win = iframe.contentWindow;
                            }
                            var message = {
                                parent: 'employer-app',
                                token: localStorage.getItem('token') || null,
                                joi: _this.applier_id,
                                type: 'employer-curriculum'
                            };
                            win.postMessage(message, '*');
                            console.log('interval send message', _this.interval);
                        }
                    }, 250);
                }
                // setTimeout(() => {
                //   const iframe = document.querySelector('iframe#ionicApp') as HTMLIFrameElement;
                //   if (iframe) {
                //     iframe.addEventListener('load', () => {
                //       setTimeout(() => {
                //         iframe.contentWindow.postMessage({
                //           parent: 'employer-app',
                //           token: localStorage.getItem('token') || null,
                //           joi: this.applier_id,
                //           type: 'employer-curriculum'
                //         }, '*');
                //       });
                //     }, false);
                //   }
                // }, 500);
            }
            else {
                _this.isLoading = false;
            }
        });
    };
    CurriculumComponent.prototype.formatBDay = function (date) {
        return moment().diff(date, 'years');
    };
    CurriculumComponent.prototype.downloadEventCV = function (event_id) {
        var _this = this;
        this.eventsService.downloadEventCV(event_id, this.applier_id)
            .subscribe(function (cvData) {
            var link;
            link = document.createElement('a');
            var formBlob = new Blob([cvData], { type: 'application/pdf' });
            link.href = window.URL.createObjectURL(formBlob);
            link.setAttribute('download', _this.applier['name'].trim() + '_' +
                _this.applier['surname'].trim() + '_CV_for_event_' + event_id + '.pdf');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    };
    CurriculumComponent.prototype.print = function (user) {
        console.log('Printing user cv', user);
        this.statuses.exportingCV = true;
        this.exportLabel = 'Generating PDF..';
        var that = this;
        var doc = new jsPDF({
            unit: 'pt'
        });
        if (user['img'] && this.includeImage) {
            var img = document.getElementsByClassName('applier_img')[0];
            img.crossOrigin = 'anonymous';
            if (user['img'].indexOf('s3.eu') > -1) {
                img.src += '?random';
            }
            html2canvas(img, {
                allowTaint: false,
                useCORS: true
            })
                .then(function (canvas) {
                var dataUrl = canvas.toDataURL('image/png');
                export_pdf({
                    data: dataUrl,
                    w: 100,
                    h: 100
                });
            }).catch(function (err) {
                console.error(err);
            });
        }
        else {
            export_pdf();
        }
        this.modalRef.hide();
        function export_pdf(img) {
            var config = {
                vertical_offset: 60,
                horizontal_offset: 60,
                format: 'JPG'
            };
            var w, h;
            if (img) {
                // console.log('img', img);
                if (img['data'].indexOf('image/png;')) {
                    config.format = 'PNG';
                }
                doc.addImage(img['data'], config['format'], config['horizontal_offset'], config['vertical_offset'], img['w'], img['h']);
                w = img['w'];
                h = img['h'];
            }
            else {
                w = 0;
                h = 0;
            }
            // Header
            doc.setFontSize(16);
            doc.setFontType('bold');
            doc.text(img ? config['horizontal_offset'] + w + 10 : config['horizontal_offset'], config['vertical_offset'] + h / 5, user['name'] + ' ' + user['surname']);
            doc.setFontSize(12);
            doc.setFontType('normal');
            config['vertical_offset'] += +h / 5 + 10;
            addHeaderRow('Email', user['contact_email']);
            addHeaderRow('Phone', user['contact_phone']);
            addHeaderRow('City', user['city_name']);
            addHeaderRow('Birthdate', moment(user['birthdate']).format('DD MMMM YYYY'));
            ///////////////////
            if (img) {
                config['vertical_offset'] += h / 2;
            }
            // University career
            addTitle('University career');
            for (var _i = user['academic_qualifications'].length - 1; _i >= 0; _i--) {
                addRow('Course', user['academic_qualifications'][_i]['course_name']);
                addRow('University', user['academic_qualifications'][_i]['university_name']);
                addRow('Qualification', user['academic_qualifications'][_i]['qualification_name']);
                addRow('Duration', moment(user['academic_qualifications'][_i]['started_at']).format('MMM YYYY') +
                    ' - ' + moment(user['academic_qualifications'][_i]['finished_at']).format('MMM YYYY'));
                if (user['academic_qualifications'][_i]['vote']) {
                    addRow('Vote', '' + user['academic_qualifications'][_i]['vote']);
                }
                else {
                    addRow('Average', '' + user['academic_qualifications'][_i]['avg']);
                }
                config['vertical_offset'] += 10;
            }
            ///////////////////
            // Experiences
            addTitle('Experiences');
            for (var _i = user['experiences'].length - 1; _i >= 0; _i--) {
                var exp = user['experiences'][_i];
                addRow('Type', exp['ExperienceType']['name']);
                addRow('Title', exp['title']);
                addRow('Description', exp['description']);
                var duration = moment(exp['started_at']).format('MMM YYYY') + ' - ' + moment(exp['finished_at']).format('MMM YYYY');
                if (!exp['started_at'] && exp['finished_at']) {
                    duration = moment(exp['finished_at']).format('MMM YYYY');
                }
                if (exp['started_at'] && !exp['finished_at']) {
                    duration = moment(exp['started_at']).format('MMM YYYY') + ' - now';
                }
                if (!exp['started_at'] && !exp['finished_at']) {
                    duration = ' - ';
                }
                addRow('Duration', duration);
                config['vertical_offset'] += 10;
            }
            ///////////////////
            // Skills
            addTitle('Skills');
            for (var i = user['skills'].length - 1; i >= 0; i--) {
                addRow(user['skills'][i]['Skill']['name'], user['skills'][i]['SkillLevel']['name']);
                config['vertical_offset'] += 10;
            }
            ///////////////////
            // Languages
            addTitle('Languages');
            for (var i = user['languages'].length - 1; i >= 0; i--) {
                addRow(user['languages'][i]['Language']['name'], user['languages'][i]['LanguageLevel']['name']);
                config['vertical_offset'] += 10;
            }
            ///////////////////
            // Save
            doc.save(user['name'] + '_' + user['surname'] + '_CV.pdf');
            that.statuses.exportingCV = false;
            ///////
            // Functions
            function addHeaderRow(title, content) {
                if (content) {
                    config['vertical_offset'] += 15;
                    doc.setTextColor(50);
                    doc.setFontType('bold');
                    doc.setFontSize(10);
                    doc.text(img ? config['horizontal_offset'] + w + 10 : config['horizontal_offset'], config['vertical_offset'], title);
                    doc.setTextColor(100);
                    doc.setFontType('normal');
                    doc.text(img ? config['horizontal_offset'] + w + 10 + 50 : config['horizontal_offset'] + 50, config['vertical_offset'], content);
                }
            }
            function addRow(title, content) {
                if (content) {
                    content = decodeContent(content);
                    var lines = doc.splitTextToSize(content, 340);
                    config['vertical_offset'] += 15;
                    checkPage();
                    doc.setTextColor(10);
                    doc.setFontSize(10);
                    doc.setFontType('bold');
                    doc.text(config['horizontal_offset'], config['vertical_offset'], title);
                    doc.setTextColor(100);
                    doc.setFontType('normal');
                    doc.text(config['horizontal_offset'] + 150, config['vertical_offset'], lines);
                    if (lines.length === 1) {
                        config['vertical_offset'] += 0;
                    }
                    else {
                        config['vertical_offset'] += 15 * (lines.length - 1);
                    }
                }
            }
            function decodeContent(content) {
                return content.replace(/à/gi, 'à').replace(/â/gi, 'a').replace(/-/gi, ' ').replace(/"/gi, '').replace(/▪/gi, '-');
            }
            function addTitle(title) {
                checkPage();
                config['vertical_offset'] += 30;
                doc.setTextColor(0);
                doc.setFontType('bold');
                doc.setFontSize(12);
                doc.text(config['horizontal_offset'], config['vertical_offset'], title);
                config['vertical_offset'] += 5;
            }
            function checkPage(lines) {
                if (config['vertical_offset'] > 770) {
                    doc.addPage();
                    config['vertical_offset'] = 80;
                }
            }
            //////////////////////////////
        }
    };
    CurriculumComponent.prototype.changeProcessStatus = function (curricula, process_status) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log(curricula);
                        if (curricula['process_status'] === process_status) {
                            process_status = 'new';
                        }
                        return [4 /*yield*/, this.jobOfferService.changeApplicationProcessStatus(curricula['applications_id'], process_status)];
                    case 1:
                        result = _a.sent();
                        curricula['process_status'] = result['process_status'];
                        this.refreshApplications();
                        return [2 /*return*/];
                }
            });
        });
    };
    CurriculumComponent.prototype.refreshApplications = function () {
        var _this = this;
        this.curriculaService.getApplications(this.applier_id)
            .subscribe(function (applications) {
            _this.applications = applications.map(function (a) {
                a.id = a['applications_id'];
                a.JobOffer.id = a.JobOffer.job_id;
                a.applied_at = a['created_at'];
                return a;
            });
            // console.log('applications', applications);
        });
    };
    // scheduleInterview
    CurriculumComponent.prototype.scheduleInterview = function (application_id, user) {
        var _this = this;
        this.dcds.postScheduleInterview(this.careerDayId, application_id, {
            recruiters: [JSON.parse(this.localStorageHelper.get('userData')).id]
        }).subscribe(function () {
            _this.toasterService.pop('success', 'Success', "The interview request with " + user.name + " " + user.surname + " has been successfully completed");
            _this.ngOnInit();
        }, function (error) {
            _this.toasterService.pop('error', 'Error!', 'Please try again.');
            console.log(error);
        });
    };
    return CurriculumComponent;
}());
export { CurriculumComponent };
